module.exports = __webpack_public_path__ + "img/Debt.548cbb6d.svg";